module.exports = __webpack_public_path__ + "img/logo_sowos.455bb5e4.svg";